import React from 'react';

/**
 * 🛰️ UNIVERSAL DATA INSPECTOR
 * Strict adherence to naming conventions. 
 * Supports an optional renderCell prop for domain-specific formatting (like URIs).
 */
const UniversalDataInspector = ({ worksheet, renderCell }) => {
    if (!worksheet || !worksheet.headers) return null;
    const { headers, sampleRows } = worksheet;

    return (
        <div className="table-responsive border rounded overflow-hidden">
            <table className="table table-sm table-bordered mb-0" style={{ fontSize: '11px', tableLayout: 'fixed' }}>
                <thead className="text-white">
                    <tr style={{ backgroundColor: '#495057' }}>
                        <th className="py-1 px-2 border-end" style={{ width: '180px' }}>Field (Header)</th>
                        {sampleRows.slice(0, 3).map((_, i) => (
                            <th key={i} className="py-1 px-2 fw-normal text-center font-monospace">
                                REC_{String(i).padStart(2, '0')}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {headers.map((header, colIndex) => (
                        <tr key={colIndex}>
                            <td className="py-0 px-2 fw-bold bg-light border-end text-truncate align-middle" style={{ height: '22px' }}>
                                {header || <em className="text-muted small">unnamed_col</em>}
                            </td>
                            
                            {sampleRows.slice(0, 3).map((row, rowIndex) => (
                                <td key={rowIndex} className="py-0 px-2 font-monospace align-middle" 
                                    style={{ letterSpacing: '-0.3px', color: '#222', wordBreak: 'break-word' }}>
                                    {/* 🎯 THE HOOK: Strategy decides how to show text/links/numbers */}
                                    {renderCell ? renderCell(row[colIndex], header) : (
                                        row[colIndex] !== undefined && row[colIndex] !== "" 
                                            ? String(row[colIndex]) 
                                            : <span className="opacity-25">--</span>
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default UniversalDataInspector;